import type { UseUserPreferencesNotificationsProps } from "./user-preferences-notifications.type";
import type { SettingsNotifications } from "@/entities/settings";

import isEqual from "lodash/isEqual";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useUpdateSettings } from "@/entities/settings";
import { useApiErrorHandler } from "@/modules/api-errors";
import { useAppNotification } from "@/modules/app-notification/app-notification.hook";

export const useUserPreferencesNotifications = ({
  userPreferencesNotifications,
}: UseUserPreferencesNotificationsProps) => {
  const { t } = useTranslation();

  const [notificationSettings, setNotificationSettings] = useState(
    userPreferencesNotifications
  );
  const { mutate, isPending } = useUpdateSettings();
  const { onError } = useApiErrorHandler();
  const { notify } = useAppNotification();

  const isDirty = !isEqual(notificationSettings, userPreferencesNotifications);

  const handleNotificationSettingsChange = (
    newSettings: SettingsNotifications
  ) => {
    setNotificationSettings(newSettings);
  };

  const onCancel = () => {
    setNotificationSettings(userPreferencesNotifications);
  };

  const onSave = () => {
    mutate(
      { notifications: notificationSettings },
      {
        onSuccess: () => {
          notify.success({
            title: t("user:preferences.notifications.updateSuccess"),
          });
        },
        onError,
      }
    );
  };

  return {
    notificationSettings,
    isPending,
    isDirty,
    onSave,
    onCancel,
    handleNotificationSettingsChange,
  };
};
